export const nullUndefTest = (value, parameterName = `?`) => {
    if (typeof value === `undefined`) {
        return { success: false, error: `${parameterName} param is undefined` };
    }
    if (value === null)
        return { success: false, error: `${parameterName} param is null` };
    return { success: true, value };
};
// export const throwNullUndef = (value: any, parameterName = `?`) => {
//   const r = nullUndef(value, parameterName);
//   if (r[ 0 ]) return;
//   throw new Error(r[ 1 ]);
// }
export const isDefined = (argument) => argument !== undefined;
